import React from "react";

export default function DownArrow() {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5009 0.279808C10.9122 0.674811 10.9122 1.33268 10.5009 1.72768L6.15378 5.90278C5.94567 6.10266 5.67292 6.19545 5.40479 6.18116C5.1366 6.1955 4.86377 6.10271 4.65562 5.90279L0.30846 1.72769C-0.10282 1.33269 -0.10282 0.674821 0.30846 0.279818C0.696912 -0.0932598 1.31058 -0.09326 1.69903 0.279818L5.4047 3.83882L9.11037 0.279808C9.49883 -0.0932695 10.1125 -0.0932693 10.5009 0.279808Z"
        // fill="white"
      />
    </svg>
  );
}
